// Check Development Mode Or Production Mode
 const isDevelopment = false;
//const isDevelopment = false;
const documentHeight = document.documentElement.clientHeight;
const profileId = "11000000";
const apiUrl = "https://cp.dhru.com/submit/";
const adminUrl = 'https://api.dhru.com/client/api/v1/';
export {isDevelopment, profileId,documentHeight,apiUrl,adminUrl}
